module.exports = __webpack_public_path__ + "static/media/Notify.c364a399.svg";